const Footer = function() {
  return (
    <footer>
      <p>Created at <a href="https://junocollege.com/">Juno College</a> by Leo Hon</p>
    </footer>
  )
}

export default Footer;